// src/Components/Whtchoose.js
import React, { useEffect, useState } from 'react';
import "./whychoose.css";
import {
  FaMicrochip,
  FaLightbulb,
  FaTelegramPlane,
  FaProjectDiagram,
  FaPalette,
  FaHeadset
} from 'react-icons/fa';
import Formpage from '../Formpage/Formpage';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Whtchoose() {


  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

   useEffect(() => {
              AOS.init({
                duration: 1000,
                once: true,
              });
          
              setTimeout(() => {
                AOS.refresh();
              }, 500);
            }, []);
  return (
    <>

      <div className="whychooseus-container">
         <section>
                    <center>
                        <div className='heading-for-all' data-aos='fade-up'>
                            <h2>Why choose us</h2>
                        </div>
                    </center>
                </section>
        <div className="whychooseus-content" data-aos='fade-up' data-aos-delay='1000'>
          <div className='about-text'>
            {/* <h2 className='heading-h2'>why choose us</h2> */}

          </div>
          <p>
            Whether you're starting from scratch or scaling your brand, we offer the complete
            <br />
            package—modern web development

            combined with powerful digital marketing strategies.
          </p>

          <div className="circle-image-wrapper">
            {/* Central content */}
            <div className="circle-text-content">
              <h2>quality & professionalism</h2>
              <p>
                Whether you're starting from scratch or scaling your brand, we offer the complete package—modern web development combined with powerful digital marketing strategies.
              </p>
            </div>

            {/* Icon + Heading pairs */}
            <div className="icon-one"><FaMicrochip /></div>
            <div className="circle-info-box info-one"><h2>Latest Tech & Trends</h2></div>

            <div className="icon-two"><FaLightbulb /></div>
            <div className="circle-info-box info-two"><h2>Measurable Results</h2></div>

            <div className="icon-three"><FaTelegramPlane /></div>
            <div className="circle-info-box info-three"><h2>Built to Perform</h2></div>

            <div className="icon-four"><FaProjectDiagram /></div>
            <div className="circle-info-box info-four"><h2>End-to-End Services</h2></div>

            <div className="icon-five"><FaPalette /></div>
            <div className="circle-info-box info-five"><h2>Tailored for Your Brand</h2></div>

            <div className="icon-six"><FaHeadset /></div>
            <div className="circle-info-box info-six"><h2>Reliable Support</h2></div>
          </div>
        </div>
      </div>

      <div className="container d-flex justify-content-center my-4"
      data-aos='fade-up' data-aos-delay='1000'>
        <button className="button-alll" onClick={handleShow}>
          Get Enquiry
        </button>
      </div>

      <Formpage show={show} onClose={handleClose} />
    </>
  );
}

export default Whtchoose;
